<!--Container Wrapper -->
<div>
  <!-- Title Row -->
  <div class="cc-tile-with-backBtn">
    <div class="title-backBtn" (click)="onMoveBackClicked()"><span class="fas fa-long-arrow-alt-left"></span></div>
    <h3>{{'_Localization_Edit_Localization_Title_Label_Text_' | translate }}</h3>
  </div>
  <!-- Header Wrapper -->
  <div class="cc-single-tab">
    <section class="cc-section-wrapper">
      <div>
        <h6 class="sub-heading">{{'_General_Basic_Settings_Text_' | translate }}</h6>
      </div>

      <div>
        <div class="row">
          <div class="col-md-4">
            <label>{{'_General_Application_Text_' | translate }}</label>
            <label class="cc-value-label">{{localizationRecordToEdit?.applicationModuleName}}</label>
          </div>
          <div class="col-md-4">
            <label>{{'_General_Key_Text_' | translate }}</label>
            <label class="cc-value-label">{{localizationRecordToEdit?.localizeKey}}</label>
          </div>
          <div class="col-md-4">
            <label>{{'_General_Default_English_Text_' | translate }}</label>
            <label class="cc-value-label">{{localizationRecordToEdit?.defaultValue}}</label>
          </div>

        </div>

        <!-- Edit Row -->
        <form [formGroup]="formGroup">
          <div class="row content-edit-area">
            <div class="col-md-4">
              <label>{{'_General_Language_Text_' | translate }}</label>
              <select formControlName="languages" class="cc-select-dropdown form-control">
                <option *ngFor="let language of languages; trackBy:languageTrackBy"
                        [ngValue]="language">{{language.languageName | translate}}</option>
              </select>
            </div>
            <div class="col-md-8 edit-language-text">
              <label>{{selectedLanguageString}} {{'_Localization_Text_Ts_Text_' | translate }}<span class="required-field" tabindex="-1">*</span></label>
              <div class="cc-textarea-container">
                <div class="cc-textarea">
                  <textarea maxlength="750" class="form-control" formControlName="editField" rows="3"  [readonly]="formGroup.get('editField')?.value==='Powered by FMSI' && permissionGroup!=='FMSI Default Group'"></textarea>
                </div>
              </div>

              <div *ngIf="showSelectedLanguageStringTextIsRequiredError(editField)">
                <div class="cc-validation" *ngIf="editField?.errors?.required == true">
                  {{selectedLanguageString}} {{'_Localization_Edit_Localization_Language_Selected_Text_Required_Text_' | translate }}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="cc-btn-panel">
        <button class="btn btn-secondary" (click)="onCancelClicked()">{{'_General_Button_Cancel_Text_' | translate }}</button>
        <button class="btn btn-primary" [disabled]="!formGroup.dirty || !formGroup.valid" (click)="onSaveClicked()">{{'_General_Button_Save_Text_' | translate }}</button>
      </div>
    </section>

  </div>
</div>
